<template>
  <div class="card">
    <h6 :class="headerColor" class="card-header custom-header text-center">
      <span>{{ title }}</span>
      <span class="mobile-counter">{{ mobileCounter }}</span>
    </h6>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    headerColor: String,
    mobileCounter: Number,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.card {
  margin: 0;
}

h6 {
  padding: 12px 5px;
}

.custom-header {
  min-width: 150px;
  .mobile-counter {
    display: none;
  }

  span {
    white-space: nowrap;
    color: #fff;
  }

  font-family: $font-family-sans-lato;
  font-size: 12px;
}

// Media queries
@media screen and (max-width: 1600px) {
  .custom-header {
    min-width: 130px;
    font-size: 10px;
  }
}

@media only screen and (max-width: 576px) {
  .custom-header {
    font-size: 13px;
    padding: 15px 0;
    &:after {
      position: absolute;
      top: 11px;
      right: 12px;
      color: #fff;
      font-size: 24px;
      opacity: 0.7;
      font-variant: normal;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      content: '\f107';
    }
    .mobile-counter {
      display: block;
      position: absolute;
      top: 16.5px;
      right: 33px;
      font-weight: 700;
      font-size: 14px;
      opacity: 0.7;
    }
  }
}
</style>
